import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #c9cfd3;
`
const st1 = css`
  fill: #ffeed0;
`
const st2 = css`
  fill: #ffffff;
`
const st3 = css`
  fill: #fee3df;
`
const st4 = css`
  fill: #273e4f;
`

class Services extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M47.5,90.1c15.5,0,27.7-2.7,27.7-2.7l1.8,7.1c0,0-11.3,3.7-29.4,3.7S18,95.6,18,95.6l1.8-8.1 C19.8,87.4,31.9,90.1,47.5,90.1z'
        />
        <path
          css={st1}
          d='M44.5,46.7c0,0-3.7-0.3-3.3-2s3.1-3.8,6.2-4c3.1-0.1,6.1,2.6,5.8,4C53,46.1,50,46.2,50,46.2v5.3 c0,0,7.1,0.9,16,7.4s9.1,21.7,9.1,21.7s-9.1,3.1-26.7,3.7c-17.5,0.6-28.6-3.1-28.6-3.1s1.1-11.4,5.6-18.8S44.3,51,44.3,51L44.5,46.7 z'
        />
        <path css={st2} d='M100,0.9v29.4l-21-4.7l1.5-23.3L100,0.9z' />
        <path
          css={st3}
          d='M79,23.2c0,0-5.4,5.4-15.5,6.9s-19.3-4.9-19.3-4.9s-6,3.9-8.9,4s-2.1-2.1-6.9-1s-5.7-2.6-5.7-2.6 s-8.3,3.2-10.6-0.4s5.4-6.9,12.4-9.4S40.4,6.1,45.9,4.9S79,6.2,79,6.2V23.2z'
        />
        <path
          css={st4}
          d='M18.8,78.2l-0.7,3c-0.2,0.9,0.4,2,1.4,2.1c0.5,0.1,13.2,2.7,28,2.7c13.8,0,27.8-2.6,28-2.7 c1-0.2,1.6-1.2,1.4-2.1l-0.7-3C76.1,64,65.6,52.2,52,50v-2.8c3.2-0.7,3.4-2.5,3.4-3.1c0-1.3-3-5.1-7.9-5.1s-7.9,3.2-7.9,5.1 c0,0.6,0.2,2.4,3.4,3.1V50C29.3,52.2,18.9,64,18.8,78.2z M47.5,41.9c2.4,0,4.4,1.4,4.4,2.2c0,0.6-3,0.5-4.4,0.5 c-1.3,0-4.4,0-4.4-0.5C43.1,43.3,45,41.9,47.5,41.9z M48.5,48.2V52c0,0-0.2,0.4-1,0.4s-1-0.4-1-0.4v-3.8H48.5z M43,53.6 c0.9,2.6,8,2.6,8.9,0C63.7,55.7,72.6,66,72.6,78.4c0,0.1,0,0.3,0,0.4l0.3,1.3c-4.2,0.7-15,2.3-25.5,2.3c-11.3,0-21.5-1.6-25.5-2.3 l0.3-1.4c0-0.1,0-0.3,0-0.4C22.3,66,31.3,55.7,43,53.6z M76.8,86.6c-0.2-1-1.4-1.6-2.3-1.3c-0.1,0-8.1,2.8-27.1,2.8 c-18.5,0-27-2.7-27.1-2.8c-0.9-0.3-2.1,0.3-2.3,1.3l-2.2,8.9c-0.1,0.5,0,1,0.2,1.4c0.3,0.4,0.7,0.7,1.2,0.8c0.1,0,13.3,2.4,30.1,2.4 c20.1,0,29.8-3.3,30.2-3.4c0.9-0.2,1.5-1.2,1.3-2.1L76.8,86.6z M47.5,96.5c-12.8,0-23.5-1.4-27.6-2.1l1.3-5.2 c3.5,0.8,12,2.4,26.4,2.4c14.6,0,22.9-1.6,26.4-2.4l1.3,4.3C71.5,94.1,62.4,96.5,47.5,96.5z M27.2,77.5L27.2,77.5 c1,0,1.8-0.8,1.8-1.8c0-7,3.6-9.8,3.8-10c0.8-0.6,0.9-1.7,0.4-2.5c-0.6-0.8-1.7-1-2.5-0.4c-0.2,0.2-5.2,3.9-5.2,12.8 C25.4,76.7,26.2,77.5,27.2,77.5z M83.2,20.1c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7 C84,18.4,83.2,19.2,83.2,20.1z M88.6,25.9l-8.2-1.3l1.4-20.9L86,3.5c1,0,1.7-0.9,1.7-1.8S86.9,0,85.9,0h-0.1l-5.7,0.3 c-0.9,0-1.6,0.7-1.7,1.6l-0.2,2.6c-6.2-0.3-26.8-1.2-30-1.1C44,3.6,41.4,4.2,36,7.5c-5,3.3-21.6,10.4-23.1,11.2 c-3.8,2-3.8,5.6-1,8.1c1.5,1.9,5.3,1.5,9.5,0.3c2.2,3.9,6.2,3.6,9.7,1.8c2.6,3.7,8.1,1.7,13.9-2.2c3,1.7,10,5,16.5,5 c6.4,0,12.2-2.9,15.5-5c0.2,0.6,0.7,1.1,1.4,1.2l9.8,1.5c0.1,0,0.2,0,0.3,0c0.9,0,1.6-0.6,1.7-1.5S89.6,26.1,88.6,25.9z M27.4,27.2 c-0.4,0-1.8,0-2.7-1.3c2.2-0.8,4.5-1.8,6.4-2.8c0.3,0.5,0.9,1,1.3,1.3C32.4,24.5,28.9,27.1,27.4,27.2z M34,27.1 c0.5-0.3,1.7-1.2,1.9-1.5c0.9,0.1,2.5,0.3,3.4,0.4C36.8,28.6,34.6,27.9,34,27.1z M77.1,22.4C74.8,24,66.4,29.6,58,27.9 c-5.8-1.2-8-2.4-9.8-3.4c-1.5-0.8-5.5-2.2-8.3-2c-6.4,0.6-8.4-4.5-2.8-4.2l15-0.4c1,0,1.7-0.8,1.7-1.8S53,14.3,52,14.4l-15,0.4 c-0.6,0-3.9,0-5.7,2.1c-0.5,0.6-1.1,1.5-1.1,2.9c-2.6,1.3-12.9,6.7-15.6,4.9c-1.2-0.8-1.1-2.2-0.1-2.7C16,21.3,32.7,13.9,38,10.6 c5.2-3.3,7.2-3.5,10.4-3.6c3-0.2,23.4,0.7,29.6,1L77.1,22.4z'
        />
      </svg>
    )
  }
}

Services.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { Services }
